import { takeEvery, put, call } from "redux-saga/effects"

// Calender Redux States
import {
    GET_MANUFACTURER_LISTING,
    GET_MANUFACTURER_DETAILS,
    ADD_MANUFACTURER,
    UPDATE_MANUFACTURER,
    DELETE_MANUFACTURER,
    EXPORT_MANUFACTURER,
} from "./actionTypes.js";

import {
    getManufacturerListingSuccess,
    getManufacturerListingFail,
    createManufacturerSuccess,
    createManufacturerFail,
    updateManufacturerSuccess,
    updateManufacturerFail,
    deleteManufacturerSuccess,
    deleteManufacturerFail,
    exportManufacturerSuccess,
    exportManufacturerFail,
    getManufacturerDetailsSuccess,
    getManufacturerDetailsFail,
} from "./actions.js";

import {
    manufacturerListingApi,
    manufacturerDetailsApi,
    updateManufacturerApi,
    deleteManufacturerApi,
    exportManufacturerApi,
    addManufacturerApi,
} from "./manufacturerApi.js";

function* fetchManufacturerListing({ payload }) {
    try {
        const response = yield call(manufacturerListingApi, payload);
        yield put(getManufacturerListingSuccess(response));
    } catch (error) {
        yield put(getManufacturerListingFail(error));
    }
}

function* fetchManufacturerDetail({ payload }) {
    try {
        const response = yield call(manufacturerDetailsApi, payload);
        yield put(getManufacturerDetailsSuccess(response));
    } catch (error) {
        yield put(getManufacturerDetailsFail(error));
    }
}

function* createManufacturer({ payload }) {
    try {
        const response = yield call(addManufacturerApi, payload);
        yield put(createManufacturerSuccess(response));
    } catch (error) {
        yield put(createManufacturerFail(error));
    }
}

function* updateManufacturer({ payload }) {
    try {
        const response = yield call(updateManufacturerApi, payload);
        yield put(updateManufacturerSuccess(response));
    } catch (error) {
        yield put(updateManufacturerFail(error));
    }
}

function* deleteManufacturer({ payload }) {
    try {
        const response = yield call(deleteManufacturerApi, payload);
        yield put(deleteManufacturerSuccess(response));
    } catch (error) {
        yield put(deleteManufacturerFail(error));
    }
}

function* exportManufacturer({ payload }) {
    try {
        const response = yield call(exportManufacturerApi, payload);
        yield put(exportManufacturerSuccess(response));
    } catch (error) {
        yield put(exportManufacturerFail(error));
    }
}

function* ManufacturerSaga() {
    yield takeEvery(GET_MANUFACTURER_LISTING, fetchManufacturerListing);
    yield takeEvery(GET_MANUFACTURER_DETAILS, fetchManufacturerDetail);
    yield takeEvery(ADD_MANUFACTURER, createManufacturer);
    yield takeEvery(UPDATE_MANUFACTURER, updateManufacturer);
    yield takeEvery(DELETE_MANUFACTURER, deleteManufacturer);
    yield takeEvery(EXPORT_MANUFACTURER, exportManufacturer);

}

export default ManufacturerSaga
